// import color from "../../../constants/color";

import color from "../../../../constants/color"

const styles = {

  tableHead: {
    color: "#878787",
    fontWeight: "400",
  },

  leaveHeading: { 
    pl: 2, 
    fontWeight: 600,
    fontSize: "20px", 
  },
  checkinBtn:
  { borderRadius: 50, 
    backgroundColor: "#28AA4A",
    color: "#fff", 
    ml: "8px" ,
    textTransform: "none", 
    fontSize: "12px",
  },
  tabledata: {
    borderBottom: 0,
  },
  actionData: 
  { borderBottom: 0 , 
    display:"flex",
    alignItems:"center",
  },

  tableAvtardata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center",
  },

  tableActiondata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "space-around", 
  },
  dropdown:{
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"8.5px 14px",
      
    },
    width:"100%",
    fontSize:"14px",
    fontWeight:"400"
  },
  dropdownMenu:{
    fontSize:"14px",
    fontWeight:"400"
  },
  modalInput:{
    display:"flex",    // backgroundColor:color.lightGray,
    borderRadius:"30px",
    // width:{ xs: "25em", md: "35em" },
    justifyContent:"center" ,// Center align on smaller screens
    my:"10px",
    height:"2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"8.5px 14px"
    },
    "& .MuiOutlinedInput-root":{
      padding:"0"
    }
  },
  inputSpace: {
    "& .MuiOutlinedInput-root":{
      padding:"0px 14px"
    }

  },
  reason:{
    borderRadius: "8px",

    width:"100%",
    mt: 1,
    height: "4.5em",},
  name:{
    color:color.text,
    fontSize:"14px",
    fontWeight:"400"
  },
  mail:{
    color:color.lightText,
    fontSize:"14px",
    fontWeight:"400"
  },
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text
  },

  hoursInput:{
    width:"100%",
    borderRadius: "8px",
    height: "2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"8.5px 14px"
    },
  },
  iconstyle:{
    width:"2.8em",
    backgroundColor:"#28AA4A33",
    borderRadius: "8px",
    height: "2.5em",
    padding:"0.6rem",
    marginTop: "1pc",
  },
  deleteIconstyle:{ 
    width:"2.8em",
    backgroundColor:"#FF000033",
    borderRadius: "8px",
    height: "2.5em",
    padding:"0.6rem",
    marginTop: "1pc",
  },
  button:{
    borderRadius: 50,
    textTransform: "none" ,
    backgroundColor: color.primary,
    ml: { xs: 0, md: "10px" },
    fontSize: "12px",
    fontWeight: "400",
  },
  dateInput:{
    width: "100%",
    "& .MuiInputBase-input": {
      padding: "8.5px 14px"
    }},
  projectContainer:{
    display: {xs:"block", md: "flex"},
    alignItems: "center", 
    gap: "20px" ,
    my:1
  }
}
export default styles
